(function() {
  function initCountdowns() {
    document.querySelectorAll('[data-countdown]').forEach(function(el) {
      if (el.dataset.countdownInit) return;
      el.dataset.countdownInit = 'true';
      
      const end = new Date(el.dataset.countdown).getTime();
      const timerEl = el.querySelector('.countdown-timer');
      if (!timerEl) return;

      function update() {
        const diff = end - Date.now();
        if (diff <= 0) {
          timerEl.textContent = 'Skaduar';
          return;
        }
        const d = Math.floor(diff / 86400000);
        const h = Math.floor((diff % 86400000) / 3600000);
        const m = Math.floor((diff % 3600000) / 60000);
        const s = Math.floor((diff % 60000) / 1000);
        
        timerEl.textContent = d > 0 ? `· ${d}d ${h}h ${m}m` : `· ${h}h ${m}m ${s}s`;
      }
      update();
      setInterval(update, 1000);
    });
  }

  document.addEventListener('DOMContentLoaded', initCountdowns);
  document.addEventListener('shopify:section:load', initCountdowns);
})();
